// import parts of Bootstrap 5
import 'bootstrap/js/dist/dom/data';
import 'bootstrap/js/dist/dom/event-handler';
import 'bootstrap/js/dist/dom/manipulator';
import 'bootstrap/js/dist/dom/selector-engine';
// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/base-component';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';
// import loadInModal
import loadInModal from './plugins/loadInModal';

import {ready} from './utils/ready';

// import swiper
import Swiper, {A11y, Navigation} from 'swiper';

// run JS when ready
ready(() => {

  // variables
  const intro = document.getElementById('intro');
  const REDelements = document.querySelectorAll('[id^="RED"]');
  const numberOfREDelements = REDelements.length;
  const app = document.getElementById('app');
  const lightsOn = document.getElementById('lights-on');
  const lightsOff = document.getElementById('lights-off');
  const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  };

  // randomly add various blink classes to RED elements in intro SVG
  const addBlinkClasses = async () => {
    for (let i = 1; i <= numberOfREDelements; i++) {
      // random RED element
      let randomREDelement = Math.floor((Math.random() * numberOfREDelements));

      // if element already has class, set i back and basically start over
      if (REDelements[randomREDelement].classList.contains('slow_blink')) {
        i--;
      } else {
        // add the class
        REDelements[randomREDelement].classList.add('slow_blink');
      }

      await sleep(50);

    }
  }

  // add the blink classes, then fade out the intro section
  addBlinkClasses().then(function () {
      intro.classList.add('fade-out');
    }
  )

  // when clicking on links with a 'load-in-modal' class, load the content in a Bootstrap modal
  loadInModal();

  // light / dark button
  lightsOn.addEventListener('click', function (event) {
    lightsOn.classList.add('active');
    lightsOff.classList.remove('active');
    app.classList.add('lights-on');
    app.classList.remove('lights-off');
  });

  lightsOff.addEventListener('click', function (event) {
    lightsOff.classList.add('active');
    lightsOn.classList.remove('active');
    app.classList.add('lights-off');
    app.classList.remove('lights-on');
  });

  // gallery carousel
  new Swiper('#gallery-carousel', {
    modules: [A11y, Navigation],
    speed: 800,
    grabCursor: true,
    slidesPerView: 1,
    loop: true,
    observer: true,
    navigation: {
      nextEl: '.gallery-carousel-button-next',
      prevEl: '.gallery-carousel-button-prev',
    },
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
  });

  // team carousel
  new Swiper('.team-carousel', {
    modules: [A11y, Navigation],
    speed: 800,
    grabCursor: true,
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2,
        loop: false,
        grabCursor: false,
      },
    },
    loop: false,
    navigation: {
      nextEl: '.team-carousel-button-next',
      prevEl: '.team-carousel-button-prev',
    },
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
  });

  lightsOff.click();

})
